/* Manchester · 2026-05-15 — Fuerza navegación en categorías padre del nav.

   Bug: el handleTouch de Symmetry (main.js:2239-2269 + delegate listener
   en línea 1977/2060) intercepta click events sobre top-level nav items
   con children, llamando onNavParentHoverIn (abre dropdown) y, en touch
   devices con innerWidth>767, también evt.preventDefault()/stopPropagation().
   Resultado: tap directo en "Hombre" abre dropdown PERO no navega a
   /collections/hombre. El usuario reporta "categorías padre no funcionan".

   El "Ver todo X" agregado al dropdown (commit db25928) resuelve parcial
   pero requiere ver el dropdown primero. Esta fix garantiza que el tap
   sobre el text del nav item navegue directo, mientras el caret/SVG sigue
   abriendo el dropdown (a través del .navigation__children-toggle sibling).
*/
(function () {
  'use strict';

  // Capture-phase delegate — corre ANTES que cualquier listener Symmetry.
  // Solo navega si el href es válido (no '#') y el link es un top-level
  // nav item — los caret-toggles tienen su propio comportamiento.
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('a.navigation__link');
    if (!link) return;
    // Skip caret toggles — esos abren el submenu intencionalmente
    if (link.classList.contains('navigation__children-toggle')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    // Asegurar que es un top-level item con children (los que tienen el bug)
    var li = link.closest('li.navigation__item--with-children');
    if (!li) return;
    // Solo procesar el link que contiene el texto principal — los nested
    // sub-links dentro del dropdown ya funcionan
    if (link.parentElement !== li) return;
    // Force navigation
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    window.location.href = href;
  }, true); // capture phase — corre antes de Symmetry handlers

  // Mismo handling para touch events (mobile)
  // Detectar tapping: touchstart → touchend en <1s sobre el mismo link
  var touchStartTarget = null;
  var touchStartTime = 0;
  document.addEventListener('touchstart', function (evt) {
    var link = evt.target.closest('a.navigation__link');
    if (!link || link.classList.contains('navigation__children-toggle')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var li = link.closest('li.navigation__item--with-children');
    if (!li || link.parentElement !== li) return;
    touchStartTarget = link;
    touchStartTime = evt.timeStamp;
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function (evt) {
    if (!touchStartTarget) return;
    var elapsed = evt.timeStamp - touchStartTime;
    var endLink = evt.target.closest('a.navigation__link');
    if (endLink === touchStartTarget && elapsed < 500) {
      var href = touchStartTarget.getAttribute('href');
      touchStartTarget = null;
      evt.preventDefault();
      evt.stopPropagation();
      window.location.href = href;
    } else {
      touchStartTarget = null;
    }
  }, { capture: true });
})();
